import React from 'react';
import shortid from 'shortid';

import DropTarget from '../src/DropTarget'


export default class Box extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        items: [],
        canDrop:false,
      };
    }
  
    handleDrop = (e) => {
      let items = this.state.items.slice();
      items.push({label: e.dragData.label, uid: shortid.generate()});
      this.setState({items: items, canDrop:true});
      this.props.updateBox(e,  {id:this.props.id, imageurl: e.dragData.label});
      e.containerElem.style.visibility="hidden";
    };
    
    swap = (fromIndex, toIndex, dragData) => {
      let items = this.state.items.slice();
      const item = {label: dragData.label, uid: shortid.generate()};
      items.splice(toIndex, 0, item);
      this.setState({items: items});
    };
  
    kill = (uid) => {
      let items = this.state.items.slice();
      const index = items.findIndex((item) => {
        return item.uid === uid
      });
      if (index !== -1) {
        items.splice(index, 1);
      }
      this.setState({items: items});
    };
  
    render() {
      /*
          Note the two layers of DropTarget. 
          This enables it to handle dropped items from 
          outside AND items dragged between boxes.
      */
      return (
        <div className="component_box"  style={this.props.style}>
          <div className={this.props.lightColor}></div>
         
          <DropTarget
              onHit={this.handleDrop}
              targetKey={this.props.targetKey}
              dropData={{name: this.props.name}}
              noDrop={this.state.canDrop}
            >
            
                <div className="box fryer">
                  {this.state.items.map((item, index) => {
                    return ( 
                      <img key={item.uid} draggable="false" alt="" style={{width: "60px", height:"60px"}} src={item.label}></img>
                    )
                  })}
                </div>
             
            </DropTarget>
          </div>
      
      );
    }
  }